import { http } from 'interfaces'

export interface LegCandidate {
  id: number
  active: boolean | null
  person_id: number | null
  role_id: number | null
  leg_role_id: number | null
  leg_district_id: number | null
  address_id: number | null
  leg_pos: string | null
  status_id: number | null
  incumbent: string | null
  percent_vote: number | null
  elect_date: string | null
  elect_code: string | null
  fec_link_num: string | null
  party_desc: string | null
  org_name: string | null
  cycle_filing_date: string | null
  updated_by: string | null
  last_updated: string | null
}

export interface ExecCandidate {
  id: number
  active: boolean | null
  person_id: number | null
  role_id: number | null
  exec_role_id: number | null
  exec_org_id: number | null
  state_id: number | null
  address_id: number | null
  exec_pos: string | null
  status_id: number | null
  incumbent: string | null
  percent_vote: number | null
  elect_date: string | null
  elect_code: string | null
  fec_link_num: string | null
  party_desc: string | null
  org_name: string | null
  cycle_filing_date: string | null
  updated_by: string | null
  last_updated: string | null
}

export async function getLegCandidatesByPerson (personId: number): Promise<LegCandidate[]> {
  const response = await http.get<LegCandidate[]>(
    `/api/v1/us/person/${personId}/leg-candidates/`
  )
  return response.data
}

export async function getExecCandidatesByPerson (personId: number): Promise<ExecCandidate[]> {
  const response = await http.get<ExecCandidate[]>(
    `/api/v1/us/person/${personId}/exec-candidates/`
  )
  return response.data
}
